/* eslint-disable */
import { Container, Paper, Text } from '@mantine/core'
import useTranslation from 'next-translate/useTranslation'

const MainTab = () => {
  const { lang } = useTranslation('client')

  return (
    <Container size="sm">
      <Paper>
        {lang === 'en' ? (
          <>
            <div style={{ marginBottom: 30 }}>
              <Text size="lg" weight={700} style={{ marginBottom: 5 }}>
                Company Name:
              </Text>
              <Text size="lg">Infinity Medical Academy</Text>
            </div>

            <div style={{ marginBottom: 30 }}>
              <Text size="lg" weight={700} style={{ marginBottom: 5 }}>
                Establishment Date:
              </Text>
              <Text size="lg">[5/2019]</Text>
            </div>

            <div style={{ marginBottom: 30 }}>
              <Text size="lg" weight={700} style={{ marginBottom: 5 }}>
                Location:
              </Text>
              <Text size="lg">
                Jeddah, Kingdom of Saudi Arabia, Al-Baghdadiyah district,
                intersection of Hail Road and Crown Prince Road.
              </Text>
            </div>

            <div style={{ marginBottom: 30 }}>
              <Text size="lg" weight={700} style={{ marginBottom: 5 }}>
                About Us:
              </Text>
              <Text size="lg">
                Infinity Medical Academy is a leading provider of high-quality
                training and educational services in healthcare. Established in
                2019, we have been dedicated to empowering individuals and
                organizations to achieve their professional and academic goals
                through innovative learning solutions and comprehensive training
                programs. The Infiniti Academy Health Training Center is one of
                the doors of health training for individuals and health
                organizations and to achieve the future vision, a working group
                of (5) members was formed where it carried out a number of
                meetings and specific tasks for some team members outside those
                meetings in order to produce an operational manual for the
                center that documents and draws a map to ensure the delivery of
                programs of high standards. This manual has been designed in
                three parts, the first part talks about organizational standards
                in terms of definitions and organizational structure that
                explains the departments based on the implementation of programs
                and the role and functions of each of the administrative
                departments. The second part contains the administrative
                policies and procedures for the implementation of the training
                process in how to manage the data of trainers and ways to
                communicate with them, equipment, tools, and financial
                resources. As the third part contains the standards of
                management of the training process and quality assurance and in
                this part a map and a path are developed that shows the
                mechanism of work and this is done through the evaluation of
                educational activities and the provision of training course
                information electronically and the evaluation of training
                programs and speakers. Infinity Academy for Health Training is
                one of the health training centers accredited by the Saudi
                Commission for Health Specialties. The Academy was founded by
                professionals in health and medical administration several years
                ago. The academy offers development activities and accredited
                certificates. The availability of activities on the ground, on
                the ground and via electronic transmission, that contribute to
                the development of the practitioner and the student in meeting
                their scientific and professional needs. Over the years,
                Infinity Academy has become one of the largest training
                providers in the Kingdom of Saudi Arabia providing continuously
                improved training services. The academy was launched in Jeddah,
                then we started expanding in the Kingdom of Saudi Arabia to
                reach Riyadh, Khobar, Jizan, and Tabuk. Infinity Academy is
                ready to continue holding and organizing courses regularly in
                Jeddah and across the Kingdom, and we hope that they always live
                up to your expectations.
              </Text>
            </div>

            <div style={{ marginBottom: 30 }}>
              <Text size="lg" weight={700} style={{ marginBottom: 5 }}>
                Mission Statement:
              </Text>
              <Text size="lg">
                Our mission is to provide an advanced, interactive electronic
                learning environment that enhances trainers' technological
                skills, thereby supporting the educational process and elevating
                the efficiency of health sector employees in meeting quality
                standards.
              </Text>
            </div>

            <div style={{ marginBottom: 30 }}>
              <Text size="lg" weight={700} style={{ marginBottom: 5 }}>
                Vision Statement:
              </Text>
              <Text size="lg">
                Our vision is to pioneer the transformation of education through
                innovative e-learning solutions, revolutionizing the way
                knowledge is acquired, shared, and applied, thereby empowering
                individuals and organizations to thrive in an ever-evolving
                world. Our vision is to achieve a distinguished and unparalleled
                electronic learning environment at the academy, characterized by
                high quality and supported by cutting-edge technology, to meet
                the evolving needs of the modern era in the Kingdom.
              </Text>
            </div>

            <div style={{ marginBottom: 30 }}>
              <Text size="lg" weight={700} style={{ marginBottom: 5 }}>
                Values:
              </Text>
              <Text size="lg">
                We believe in cooperation, diversity, uniqueness, quality, and
                support.
              </Text>
            </div>

            <div style={{ marginBottom: 30 }}>
              <Text size="lg" weight={700} style={{ marginBottom: 5 }}>
                Goals and Objectives:
              </Text>
              <ul>
                <li>
                  <Text size="lg">
                    Stimulating Learning Process: Create an electronic
                    environment that fosters engagement and active learning
                    among trainees, resulting in maximum academic benefit.
                  </Text>
                </li>
                <li>
                  <Text size="lg">
                    Skill Development: Enhance trainees' abilities to adapt to
                    contemporary changes through the utilization of modern
                    technologies, thus fostering skill development.
                  </Text>
                </li>
                <li>
                  <Text size="lg">
                    Quality Improvement: Improve the quality of the educational
                    process by implementing teaching methods grounded in
                    e-learning technologies, ensuring relevance and
                    effectiveness.
                  </Text>
                </li>
                <li>
                  <Text size="lg">
                    Enhancing E-learning Systems: Develop and enhance the
                    center's e-learning systems to create a robust and impactful
                    educational environment.
                  </Text>
                </li>
                <li>
                  <Text size="lg">
                    Promoting Cooperation: Encourage collaboration and
                    coordination with external stakeholders in the e-learning
                    and training sectors to leverage collective expertise and
                    resources.
                  </Text>
                </li>
                <li>
                  <Text size="lg">
                    Establishing Identity: Create a distinctive and systematic
                    reference for the center's identity in the realm of
                    e-learning, reflecting its commitment to excellence.
                  </Text>
                </li>
              </ul>
            </div>

            <div style={{ marginBottom: 30 }}>
              <Text size="lg" weight={700} style={{ marginBottom: 5 }}>
                Target Audience:
              </Text>
              <Text size="lg">
                Our target audience includes professionals seeking to enhance
                their skills or advance their careers, students pursuing
                academic studies in health and medicals, and organizations
                looking to invest in employee training and development.
              </Text>
            </div>

            <div>
              <Text size="lg" weight={700} style={{ marginBottom: 5 }}>
                Contact Information:
              </Text>
              <Text size="lg">Infinity Medical Academy</Text>
              <Text size="lg">Al-Baghdadiyah district</Text>
              <Text size="lg">Hail Road and Crown Prince Road</Text>
              <Text size="lg">Jeddah, Kingdom of Saudi Arabia</Text>
              <Text size="lg">
                Phone Number: <a href="tel:+966570322051">+966570322051</a>
              </Text>
              <Text size="lg">
                Email:{' '}
                <a href="mailto:info@infinity.edu.sa">info@infinity.edu.sa</a>
              </Text>
              <Text size="lg">
                Website:{' '}
                <a href="https://infinity.edu.sa" target="_blank">
                  https://infinity.edu.sa
                </a>
              </Text>
            </div>
          </>
        ) : (
          <>
            <div style={{ marginBottom: 30 }}>
              <Text size="lg" weight={700} style={{ marginBottom: 5 }}>
                اسم الشركة:
              </Text>
              <Text size="lg">Infinity Medical Academy</Text>
            </div>

            <div style={{ marginBottom: 30 }}>
              <Text size="lg" weight={700} style={{ marginBottom: 5 }}>
                تاريخ التأسيس:
              </Text>
              <Text size="lg">[5/2019]</Text>
            </div>

            <div style={{ marginBottom: 30 }}>
              <Text size="lg" weight={700} style={{ marginBottom: 5 }}>
                الموقع:
              </Text>
              <Text size="lg">
                جدة، المملكة العربية السعودية، حي البغدادية، تقاطع طريق حائل
                وطريق الأمير السعود.
              </Text>
            </div>

            <div style={{ marginBottom: 30 }}>
              <Text size="lg" weight={700} style={{ marginBottom: 5 }}>
                من نحن:
              </Text>
              <Text size="lg">
                أكاديمية الطب اللانهائي هي مقدمة رائدة للخدمات التدريبية
                والتعليمية ذات الجودة العالية في مجال الرعاية الصحية. تأسست في
                عام 2019، حرصت على تمكين الأفراد والمنظمات من تحقيق أهدافهم
                المهنية والأكاديمية من خلال حلول التعلم الابتكارية وبرامج
                التدريب الشاملة. يعتبر مركز تدريب الطب اللانهائي باباً من أبواب
                التدريب الصحي للأفراد والمؤسسات الصحية ولتحقيق الرؤية المستقبلية
                تم تشكيل مجموعة عمل من (5) أعضاء قامت بعدة اجتماعات ومهام محددة
                لبعض أعضاء الفريق خارج تلك الاجتماعات من أجل إنتاج دليل تشغيلي
                للمركز يوثق ويرسم خريطة لضمان تقديم برامج عالية المعايير. تم
                تصميم هذا الدليل في ثلاثة أجزاء، الجزء الأول يتحدث عن المعايير
                التنظيمية من حيث التعريفات والهيكل التنظيمي الذي يوضح الأقسام
                بناءً على تنفيذ البرامج ودور ووظائف كل إدارة. الجزء الثاني يحتوي
                على السياسات والإجراءات الإدارية لتنفيذ عملية التدريب في كيفية
                إدارة بيانات المدربين وطرق التواصل معهم والمعدات والأدوات
                والموارد المالية. كما يحتوي الجزء الثالث على معايير إدارة عملية
                التدريب وضمان الجودة وفي هذا الجزء يتم تطوير خريطة ومسار يظهر
                آلية العمل ويتم ذلك من خلال تقييم الأنشطة التعليمية وتوفير
                معلومات دورات التدريب بشكل إلكتروني وتقييم البرامج التدريبية
                والمتحدثين. أكاديمية الطب اللانهائي للتدريب الصحي هي واحدة من
                المراكز التدريبية الصحية المعتمدة من قبل الهيئة السعودية
                للتخصصات الصحية. تأسست الأكاديمية من قبل محترفين في مجال إدارة
                الصحة والطب منذ عدة سنوات. تقدم الأكاديمية أنشطة تطويرية وشهادات
                معتمدة. توفر توفر الأنشطة على الأرض وعبر الإرسال الإلكتروني،
                الذي يسهم في تطوير الممارس والطالب في تلبية احتياجاتهم العلمية
                والمهنية. على مر السنين، أصبحت أكاديمية الطب اللانهائي واحدة من
                أكبر مقدمي الدورات التدريبية في المملكة العربية السعودية، وتقدم
                خدمات تدريبية محسنة باستمرار. تم إطلاق الأكاديمية في جدة، ثم
                بدأنا في التوسع في المملكة العربية السعودية لنصل إلى الرياض،
                والخبر، وجيزان، وتبوك. أكاديمية الطب اللانهائي مستعدة لمواصلة
                عقد وتنظيم الدورات بانتظام في جدة وفي جميع أنحاء المملكة، ونأمل
                أن تستمر في تلبية توقعاتكم دائمًا.
              </Text>
            </div>

            <div style={{ marginBottom: 30 }}>
              <Text size="lg" weight={700} style={{ marginBottom: 5 }}>
                بيان الرسالة:
              </Text>
              <Text size="lg">
                رسالتنا هي توفير بيئة تعلم إلكترونية متقدمة وتفاعلية تعزز مهارات
                المدربين التكنولوجية، وبالتالي دعم العملية التعليمية ورفع كفاءة
                موظفي القطاع الصحي في تحقيق معايير الجودة.
              </Text>
            </div>

            <div style={{ marginBottom: 30 }}>
              <Text size="lg" weight={700} style={{ marginBottom: 5 }}>
                بيان الرؤية:
              </Text>
              <Text size="lg">
                رؤيتنا هي أن نكون روادًا في تحويل التعليم من خلال حلول التعلم
                الإلكترونية المبتكرة، مما يقلب طريقة اكتساب المعرفة ومشاركتها
                وتطبيقها، وبالتالي تمكين الأفراد والمنظمات من الازدهار في عالم
                يتطور باستمرار. رؤيتنا هي تحقيق بيئة تعلم إلكترونية متميزة ولا
                مثيل لها في الأكاديمية، تتميز بالجودة العالية ومدعومة بأحدث
                التكنولوجيا، لتلبية الاحتياجات المتطورة للعصر الحديث في المملكة.
              </Text>
            </div>

            <div style={{ marginBottom: 30 }}>
              <Text size="lg" weight={700} style={{ marginBottom: 5 }}>
                القيم:
              </Text>
              <Text size="lg">
                نؤمن بالتعاون والتنوع والتفرد والجودة والدعم.
              </Text>
            </div>

            <div style={{ marginBottom: 30 }}>
              <Text size="lg" weight={700} style={{ marginBottom: 5 }}>
                الأهداف والمبادرات:
              </Text>
              <ul>
                <li>
                  <Text size="lg">
                    تحفيز عملية التعلم: إنشاء بيئة إلكترونية تعزز المشاركة
                    والتعلم النشط بين المتدربين، مما يؤدي إلى الاستفادة
                    الأكاديمية القصوى.
                  </Text>
                </li>
                <li>
                  <Text size="lg">
                    تطوير المهارات: تعزيز قدرات المتدربين على التكيف مع
                    التغييرات المعاصرة من خلال استخدام التكنولوجيا الحديثة،
                    وبالتالي تعزيز تطوير المهارات.
                  </Text>
                </li>
                <li>
                  <Text size="lg">
                    تحسين الجودة: تحسين جودة العملية التعليمية من خلال تنفيذ
                    أساليب التدريس المبنية على تقنيات التعلم الإلكتروني، مما
                    يضمن الصلة والفعالية.
                  </Text>
                </li>
                <li>
                  <Text size="lg">
                    تعزيز أنظمة التعلم الإلكتروني: تطوير وتعزيز أنظمة التعلم
                    الإلكتروني في المركز لإنشاء بيئة تعليمية قوية ومؤثرة.
                  </Text>
                </li>
                <li>
                  <Text size="lg">
                    تعزيز التعاون: تشجيع التعاون والتنسيق مع أصحاب المصلحة
                    الخارجيين في قطاعات التعلم الإلكتروني والتدريب للاستفادة من
                    الخبرات والموارد الجماعية.
                  </Text>
                </li>
                <li>
                  <Text size="lg">
                    إنشاء هوية: إنشاء مرجع مميز ومنهجي لهوية المركز في مجال
                    التعلم الإلكتروني، معبرًا عن التزامه بالتميز.
                  </Text>
                </li>
              </ul>
            </div>

            <div style={{ marginBottom: 30 }}>
              <Text size="lg" weight={700} style={{ marginBottom: 5 }}>
                الجمهور المستهدف:
              </Text>
              <Text size="lg">
                يشمل جمهورنا المستهدف المهنيين الذين يسعون لتعزيز مهاراتهم أو
                تقدم مسيرتهم المهنية، والطلاب الذين يسعون للحصول على دراسات
                أكاديمية في مجالات الصحة والطب، والمؤسسات التي تسعى للاستثمار في
                تدريب وتطوير الموظفين.
              </Text>
            </div>

            <div>
              <Text size="lg" weight={700} style={{ marginBottom: 5 }}>
                معلومات الاتصال:
              </Text>
              <Text size="lg">أكاديمية الطب اللانهائي</Text>
              <Text size="lg">حي البغدادية</Text>
              <Text size="lg">طريق حائل وطريق الأمير السعود</Text>
              <Text size="lg">جدة، المملكة العربية السعودية</Text>
              <Text size="lg">
                رقم الهاتف: <a href="tel:+966570322051">+966570322051</a>
              </Text>
              <Text size="lg">
                البريد الإلكتروني:{' '}
                <a href="mailto:info@infinity.edu.sa">info@infinity.edu.sa</a>
              </Text>
              <Text size="lg">
                الموقع الإلكتروني:{' '}
                <a href="https://infinity.edu.sa" target="_blank">
                  https://infinity.edu.sa
                </a>
              </Text>
            </div>
          </>
        )}
      </Paper>
    </Container>
  )
}

export default MainTab
